<template>
  <validation-provider :rules="rules" :name="`${tab}.${field}`" v-slot="{ valid, errors, changed }">
    <b-input-group>
      <b-button :id="`${tab}.${field}`" v-if="helpText" class="help-icon">?</b-button>
      <b-popover v-if="helpText" :target="`${tab}.${field}`" triggers="hover" placement="top">
        <template v-slot:title>Info</template>
        {{helpText}}
      </b-popover>

      <b-form-checkbox-group
        v-if="Array.isArray(value)"
        :value="value"
        :options="value"
        v-model="localField"
        stacked
        @change="updateField"
      >
      </b-form-checkbox-group>

      <b-form-checkbox
        v-else
        :state="onValidateField(valid, errors, changed)"
        v-model="localField"
        @change="updateField"
        unchecked-value=""
      >
        {{labelText}}
      </b-form-checkbox>

      <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
    </b-input-group>
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { mapState } from 'vuex'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      localField: ''
    }),
    created () {
      this.localField = this.getField
    },
    components: {
      ValidationProvider
    },
    props: {
      tab: {
        type: String,
        required: true
      },
      helpText: String,
      field: {
        type: String,
        required: true
      },
      value: {
        type: [String, Array]
      },
      placeholder: String,
      className: String,
      rules: String,
      labelText: {
        type: String,
        required: true
      }
    },
    computed: mapState({
      getField (state) {
        const { tab, field } = this
        return state.application.createApplication.formData[tab][field]
      }
    }),
    methods: {
      updateField (value) {
        const { tab, field } = this

        this.$store.commit('application/SET_FORMFIELD_VALUE', {
          tab,
          field,
          value
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    }
  }
</script>
